import React from "react"
import { Helmet } from "react-helmet"
import { Locale } from "./locale"

interface MetaType {
  [key: string]: string
}

const meta: {[key: string]: MetaType} = {
  title: {
    ko: "핵클: A/B 테스트, 기능 플래그 및 이상 징후 탐지 플랫폼",
    en: "Hackle: Feature Management, A/B Testing + Anomaly Detection",
  },
  description: {
    ko: "제품 개선을 빠르게 반복하고 효과를 데이터로 측정합니다. 핵클 A/B 테스트 플랫폼과 기능 플래그를 통해 프로덕트의 성장을 극대화할 수 있습니다.",
    en: "Reduce deployment and decision making headaches by coding first, experimenting next, releasing confidently with Hackle.",
  },
  ogTitle: {
    ko: "핵클: A/B 테스트, 기능 플래그 및 이상 징후 탐지 플랫폼",
    en: "Hackle: Feature Management, A/B Testing + Anomaly Detection",
  },
}

export default function Meta() {
  const { lang } = Locale.getDefault()

  return (
    <Helmet titleTemplate="%s">
      <html lang={lang} />
      <title>{meta.title[lang]}</title>
      <meta name="description" content={meta.description[lang]} />
      <meta property="og:title" content={meta.ogTitle[lang]} />
      <meta property="og:locale" content={lang === "ko" ? "ko" : "en"} />
      <meta property="og:locale:alternate" content={lang === "ko" ? "en" : "ko"} />
    </Helmet>
  )
}
